import script from "./FieldControlLocalized.vue?vue&type=script&lang=ts&setup=true"
export * from "./FieldControlLocalized.vue?vue&type=script&lang=ts&setup=true"

import "./FieldControlLocalized.vue?vue&type=style&index=0&id=1b99dbc6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b99dbc6"]])

export default __exports__